import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-no-ssr.js");
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/ella/page.style.scss");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/common/AppShellLayer/AppShellLayer.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/common/Ella/Ella.tsx")